import { ReactElement, useEffect, useState } from 'react';
import { NftPurchaseFail } from '../../__partials/NftPurchaseFail';
import { NftPurchasePending } from '../../__partials/NftPurchasePending';
import { NftPurchaseSuccess } from '../../__partials/NftPurchaseSuccess';
import { placeOrder } from 'appRedux/restApi';
import { isMobile } from 'utils';

type PaymentStatusPlainProps = {
  handleSetSuccessStep?: () => void;
  setSuccessWithoutChecks?: boolean;
  nftId?: number;
  isParticipatingInRaffle?: boolean;
};

export const PaymentStatusPlain = ({
  handleSetSuccessStep,
  setSuccessWithoutChecks,
  nftId,
  isParticipatingInRaffle
}: PaymentStatusPlainProps) => {
  const [messageComponent, setMessageComponent] =
    useState<ReactElement>(NftPurchasePending);

  useEffect(() => {
    const params = {
      payment_method: 'stripe',
      payment_intent_method: 'mock-stripe-method',
      payment_intent_id: 'mock-stripe-id'
    };

    void placeOrder(nftId, params, (success, error) => {
      if (success) {
        if (setSuccessWithoutChecks) {
          setMessageComponent(() => (
            <NftPurchaseSuccess
              isParticipatingInRaffle={isParticipatingInRaffle}
            />
          ));
          return;
        }
        if (isMobile()) {
          setMessageComponent(() => (
            <NftPurchaseSuccess
              isParticipatingInRaffle={isParticipatingInRaffle}
            />
          ));
        } else {
          if (handleSetSuccessStep) {
            handleSetSuccessStep();
          }
        }
      }
      if (error) {
        setMessageComponent(NftPurchaseFail);
      }
    });
    localStorage.setItem('paymentPending', JSON.stringify(false));
  }, [setSuccessWithoutChecks, nftId, isParticipatingInRaffle]);

  return messageComponent;
};
